import { LoginAvatar } from "@invosys/invosys-ui";
import React from "react";
import PropTypes from "prop-types";

const Avatar = (props) => (
  <LoginAvatar
    displayName={document.getElementById("react_displayName").value}
    isAdministrator={
      document.getElementById("react_isAdministrator").value === "true"
    }
    isSysAdmin={document.getElementById("react_isSysAdmin").value === "true"}
    clientId={document.getElementById("react_clientId").value}
    clientName={document.getElementById("react_clientName").value}
    currentClientId={document.getElementById("react_currentAccountId").value}
    hasChildren={document.getElementById("react_hasChild").value === "true"}
    auditUserEmail={document.getElementById("react_auditUserEmail").value}
    auditUserId={document.getElementById("react_auditUserId").value}
    passwordAge={document.getElementById("react_passwordAge").value}
    namePlacement={props.namePlacement}
  />
);

Avatar.propTypes = {
  namePlacement: PropTypes.string,
};

export default Avatar;
